class webSocketClass {
  constructor (name) {
    this.lockReconnect = false
    this.localUrl = `ws://${location.host}/websocket`
    // this.localUrl = `ws://192.168.101.240:34000`
    this.wsUrl = ''
    this.globalCallback = null
    this.userClose = false
    this.createWebSocket(name)
  }
  createWebSocket (url) {
    let that = this
    that.wsUrl = url
    try {
      that.ws = new WebSocket(that.localUrl + that.wsUrl)
      that.initEventHandle()
    } catch (e) {
      console.log(`createWebSocket:${e}`)
      that.reconnect(url)
    }
  }
  initEventHandle () {
    let that = this
    that.ws.onopen = function () {
      console.log('连接成功')
    }
    that.ws.onclose = function () {
      console.log(`ws.onclose`)
      if (!that.userClose) {
        that.reconnect(that.wsUrl)
      } else {
        console.log('已断开')
      }
    }
    that.ws.onerror = function () {
      console.log(`ws.onerror`)
      if (!that.userClose) {
        that.reconnect(that.wsUrl)
      }
    }
    that.ws.onmessage = function () {
      that.getWebSocketMsg(that.globalCallback)
    }
  }
  reconnect (url) {
    let that = this
    if (that.lockReconnect) return
    that.lockReconnect = true
    setTimeout(function () {
      that.createWebSocket(url)
      that.lockReconnect = false
    }, 30000)
  }
  webSocketSendMsg (msg) {
    this.ws.send(msg)
  }
  getWebSocketMsg (callback) {
    this.ws.onmessage = ev => {
      callback && callback(ev)
    }
  }
  closeSocket () {
    let that = this
    if (that.ws) {
      that.userClose = true
      that.ws.close()
    }
  }
}
export default webSocketClass



// WEBPACK FOOTER //
// ./src/javascript/webSocket.js